<section class="adjust-hit-overview">
  <section class="header">
    <span class="title">Adjust Hit Overview </span>
  </section>
  <section class="columns-container">
    <app-hit-overview-columns
      [columns]="columns"
      (columnChanged)="columns = $event"
    ></app-hit-overview-columns>
  </section>
</section>
